export default "__VITE_ASSET__e5280899__"